import { GroupIcon } from "assests/GmsIcons";
import React, { useEffect, useState, useRef } from "react";
import useClickOutside from "Components/GMS/CustomHooks/useClickOutside";

type optionType = {
  label: string;
  value: string;
};
type propType = {
  id: string;
  onChange: Function;
  value: string;
  options: optionType[];
  name: string;
  disabled?: boolean;
  isSearchable?: boolean;
};
const ItemImportDropdown = (props: propType) => {
  const [selectedOptionLabel, setSelectedOptionLabel] = useState<string>("Select");
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filteredOptions, setFilteredOptions] = useState<optionType[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const { showMenu, ref, handleClick } = useClickOutside();
  const menuRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const option = props?.options?.filter(
      (x: any) => x?.value === props?.value
    );
    setSelectedOptionLabel(option[0]?.label);
  }, [props?.value, props?.options]);

  useEffect(() => {
    setFilteredOptions(
      props?.options?.filter(
        (option) =>
          option?.label?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, props.options]);

  useEffect(() => {
    if (showMenu && selectedIndex !== -1 && menuRef.current) {
      const selectedOptionElement = menuRef.current.childNodes[
        selectedIndex
      ] as HTMLElement;
      selectedOptionElement?.scrollIntoView({ block: "center" });
    }
  }, [showMenu, selectedIndex]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (showMenu) {
      if (e.key === "ArrowUp" && selectedIndex > 0) {
        setSelectedIndex(selectedIndex - 1);
      } else if (
        e.key === "ArrowDown" &&
        selectedIndex < filteredOptions.length - 1
      ) {
        setSelectedIndex(selectedIndex + 1);
      } else if (e.key === "Enter" && selectedIndex !== -1) {
        const selectedValue = filteredOptions[selectedIndex]?.value;
        props.onChange(selectedValue);
        handleClick();
      }
    }
  };

  return (
    <React.Fragment>
      <div id={props.id} className="tw-flex tw-w-full tw-bg-blue">
        <div
          id={`${props.id}-container`}
          ref={ref}
          className={`tw-relative ${props?.disabled ? "tw-bg-gray": "tw-bg-slate-200"} tw-w-full`}
          onKeyDown={handleKeyDown}
        >
          <div
            id={`${props.id}-trigger`}
            onClick={props?.disabled ? () => {} : handleClick}
            className={`${showMenu ? "tw-bg-[#EBECF0] tw-border" : ""} ${
              props?.disabled ? "" : "hover:tw-bg-[#EBECF0]"
            }  tw-border tw-p-2  tw-rounded-[4px] tw-flex flex-row tw-items-center tw-justify-between tw-gap-[6px] tw-w-full`}
          >
            <button
              id={`${props.id}-select-btn`}
              disabled={props?.disabled}
              className={`tw-text-blue-800 tw-text-sm tw-font-normal tw-w-auto`}
            >
              <span id={`${props.id}-selected-text`} className="tw-ms-2 tw-text-blue-800 tw-text-sm tw-line-clamp-1 tw-text-start">
                {selectedOptionLabel ? selectedOptionLabel : props?.name}
              </span>
            </button>
            <GroupIcon />
          </div>
          {showMenu && (
            <div
              id={`${props.id}-menu`}
              ref={menuRef}
              className="tw-absolute tw-z-50 tw-w-auto tw-bg-white tw-pr-4 tw-rounded-bl tw-rounded-br tw-shadow tw-overflow-y-auto tw-max-h-[300px]"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {props?.isSearchable && (
                <input
                  id={`${props.id}-search`}
                  type="text"
                  placeholder="Search..."
                  className="tw-w-full tw-h-full tw-px-2.5 tw-py-2 tw-ml-2 tw-mt-2 tw-bg-white tw-rounded tw-border tw-border-gray tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex"
                  value={searchTerm}
                  onChange={handleInputChange}
                />
              )}
              {filteredOptions.length > 0 ? filteredOptions?.map((option: optionType, index: number) => (
                <div
                  id={`${props.id}-option-${index}`}
                  key={index}
                  onClick={() => {
                    props?.onChange(option?.value);
                    handleClick();
                  }}
                  className={`tw-w-full tw-flex tw-justify-between tw-items-center tw-py-2 tw-pr-2.5 hover:tw-bg-[#dee3f6] ${
                    selectedIndex === index ? "tw-bg-[#dee3f6]" : ""
                  }`}
                >
                  <label 
                    id={`${props.id}-option-label-${index}`}
                    className={`tw-ms-2 tw-text-[#091E42] tw-text-sm`}
                  >
                    {option?.label}
                  </label>
                </div>
              )) : (
                <div
                  id={`${props.id}-no-results`}
                  className={`tw-w-full tw-flex tw-justify-between tw-items-center tw-py-2 tw-pr-2.5`}
                >
                  <label 
                    id={`${props.id}-no-results-text`}
                    className={`tw-ms-2 tw-text-[#091E42] tw-text-sm`}
                  >
                    Not found
                  </label>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ItemImportDropdown;
